let isProduction = process.env.NODE_ENV === 'production'

const URL = `https://portal.biavarzesh.ir/api/`

export const api = {
  baseUrl: URL,
  login: 'signup',
  verifyCode: 'verify'
}
